import {observer} from "mobx-react";
import {useStores} from "../../Hooks";
import React, {useEffect, useState} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {SurveyQuestionTypeEnum} from "../../serverClientShared/sharedEnums";
import RatingScaleQuestion from "./SurveyQuestionByType/RatingScaleQuestion";
import YesOrNoQuestion from "./SurveyQuestionByType/YesOrNoQuestion";
import TextQuestion from "./SurveyQuestionByType/TextQuestion";
import MultiChoiceQuestion from "./SurveyQuestionByType/MultiChoiceQuestion";

const SurveyQuestion = observer(({question, index})=> {
    const {generalStore, rtcStore, modalStore, surveyStore} = useStores();
    const getComponentByQuestionType = (question) => {
        switch (question.QuestionType) {
            case SurveyQuestionTypeEnum.TEXT_RESPONSE: return <TextQuestion question={question} index={index}/>;
            case SurveyQuestionTypeEnum.YES_NO: return <YesOrNoQuestion question={question} index={index}/>;
            case SurveyQuestionTypeEnum.RATING_SCALE: return <RatingScaleQuestion question={question} index={index}/>;
            case SurveyQuestionTypeEnum.MULTIPLE_CHOICE: return <MultiChoiceQuestion question={question} index={index}/>;
            default: return null
        }
    }

    return (
        <>
            <ConditionalComponent if={Object.values(SurveyQuestionTypeEnum).includes(question.QuestionType)}>
                <div id={index} className="bg-windowsandmenus-normal p-3 text-main-normal flex flex-col gap-1 border-[1px] border-panels-normal rounded-menu relative" style={{width: '100%', height: '100%',  outlineOffset: '-1px', fontSize: 14}}>
                    <div className="font-bold">{generalStore.translate('Question')} {index+1}: </div>
                    <div>{question.QuestionText[surveyStore.currentLanguage]}</div>
                    {getComponentByQuestionType(question)}
                </div>
            </ConditionalComponent>
        </>
    );
});

export default SurveyQuestion;
